import { AssignableRolesResponse } from '../../types/permissions.types'

export const mockAssignableRolesResponse: AssignableRolesResponse = [
  {
    id: 'donations',
    area: 'Finance',
    name: 'Donations',
    description: 'Manage donation settings and configurations',
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view donation data and reports',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage donation settings and configurations',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to donation management and settings',
      },
    ],
  },
  {
    id: 'grants',
    area: 'Grants',
    name: 'Grants',
    description: 'Manage grant programs and applications',
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view grant programs and applications',
      },
      {
        id: 'reviewer',
        name: 'Reviewer',
        description: 'Can review and score grant applications',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage grant programs and settings',
      },
      {
        id: 'admin',
        name: 'Admin',
        description: 'Full access to grant management and administration',
      },
    ],
  },
  {
    id: 'volunteering',
    area: 'Giving',
    name: 'Volunteering',
    description: 'Manage volunteering opportunities and programs',
    roles: [
      {
        id: 'reader',
        name: 'Reader',
        description: 'Can view volunteering opportunities and data',
      },
      {
        id: 'coordinator',
        name: 'Coordinator',
        description: 'Can coordinate volunteering events and activities',
      },
      {
        id: 'manager',
        name: 'Manager',
        description: 'Can manage volunteering programs and settings',
      },
    ],
  },
]
